exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins);", ""]);

// Module
exports.push([module.id, ".RunHistoryList-module__run_history_list_table_wrapper__2uhVT {\n  clear: left;\n  overflow: hidden;\n  position: relative;\n}\n:root {\n  --status-color-complete: #ffffff;\n  --status-color-aborted: #d1d0ce;\n  --status-color-queued: #ffc;\n  --status-color-error: #ffd5d5;\n  --status-color-executing: #efe;\n  --status-color-default: #f5f5f5;\n}\n", ""]);

// Exports
exports.locals = {
	"run_history_list_table_wrapper": "RunHistoryList-module__run_history_list_table_wrapper__2uhVT"
};